module.exports = __webpack_public_path__ + "img/icon-pre-complete.054f64b0.svg";